module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appContainer",
    on: {
      "click": function($event) {
        _vm.closeSiteBasket($event)
      }
    }
  }, [_c('div', {
    staticClass: "page"
  }, [(!_vm.disablePictureWall) ? _c('div', {
    staticClass: "rightSection u-pull-right"
  }, [_c('site-basket'), _vm._v(" "), _c('div', {
    staticClass: "rightMenu"
  }, [_c('saved-walls-picker', {
    ref: "savedWalls"
  }), _vm._v(" "), _c('div', {
    staticClass: "button mobileBottomMenuToggle",
    on: {
      "click": _vm.toggleMobileMenu
    }
  }, [(!_vm.mobileBottomMenuActive) ? _c('i', {
    staticClass: "fa fa-chevron-up"
  }) : _vm._e(), _vm._v(" "), (_vm.mobileBottomMenuActive) ? _c('i', {
    staticClass: "fa fa-chevron-down"
  }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.$t('menu')) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.toggleSavedWallsPicker
    }
  }, [(!_vm.savedWallsPickerActive) ? _c('i', {
    staticClass: "fa fa-chevron-down hide-for-mobile"
  }) : _vm._e(), _vm._v(" "), (_vm.savedWallsPickerActive) ? _c('i', {
    staticClass: "fa fa-chevron-up hide-for-mobile"
  }) : _vm._e(), _vm._v(" "), (!_vm.savedWallsPickerActive) ? _c('i', {
    staticClass: "fa fa-chevron-up show-for-mobile-inline"
  }) : _vm._e(), _vm._v(" "), (_vm.savedWallsPickerActive) ? _c('i', {
    staticClass: "fa fa-chevron-down show-for-mobile-inline"
  }) : _vm._e(), _vm._v("\n              " + _vm._s(_vm.$t('savedWalls')) + "\n            ")]), _vm._v(" "), _c('div', {
    class: {
      mobileBottomMenuItems: true, active: _vm.mobileBottomMenuActive
    }
  }, [_c('div', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.price <= 0
    },
    on: {
      "click": _vm.openSave
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" " + _vm._s(_vm.$t('save')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.share
    }
  }, [_c('i', {
    staticClass: "fa fa-share"
  }), _vm._v(" " + _vm._s(_vm.$t('share')) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.resetPictureWall
    }
  }, [_c('i', {
    staticClass: "icon-picture-wall"
  }), _vm._v("  " + _vm._s(_vm.$t('createNew')) + " ")]), _vm._v(" "), (_vm.locale == 'sv') ? _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.wgURL + '/general/Desenio-picture-wall.pdf'
    }
  }, [_vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "buyRightContainer u-pull-right"
  }, [_c('div', {
    staticClass: "cartContainer u-pull-left",
    on: {
      "click": _vm.toggleSiteBasket
    }
  }, [_c('div', {
    staticClass: "qty"
  }, [_vm._v(" " + _vm._s(_vm.siteBasketQty) + " ")]), _vm._v(" "), _c('i', {
    staticClass: "cart-icon"
  })]), _vm._v(" "), (!_vm.device.isMobile) ? _c('a', {
    attrs: {
      "href": _vm.checkoutUrl
    }
  }, [_c('div', {
    staticClass: "fullButton u-pull-right text-center cta black"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t('toCheckout')) + " "), _c('div', {
    staticClass: "basketSum",
    domProps: {
      "innerHTML": _vm._s(_vm.siteBasketSum)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fullButton u-pull-right text-center cta black addToCartMobile",
    on: {
      "click": _vm.buy
    }
  }, [_c('loader', {
    attrs: {
      "classes": "",
      "inline": true,
      "identifier": "buyButton"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "largePhone"
  }, [_vm._v(" " + _vm._s(_vm.$t('addToCart')) + " "), _c('img', {
    staticClass: "bagImg",
    attrs: {
      "src": _vm.wgURL + '/icons/shopbag.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "smallPhone"
  }, [_vm._v(" " + _vm._s(_vm.$t('addToCartSmall')) + " "), _c('img', {
    staticClass: "bagImg",
    attrs: {
      "src": _vm.wgURL + '/icons/shopbag.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basketSum"
  }, [_c('price', {
    attrs: {
      "inline": true
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "breadcrumbs hide-for-mobile"
  }, [_c('a', {
    attrs: {
      "href": _vm.$t('pageUrl')
    }
  }, [_vm._v(_vm._s(_vm.$t('breadcrumbPrints')) + " /")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.$t('breadcrumbInspLink')
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('breadcrumbInsp')) + " /")]), _vm._v(" "), _c('a', {
    staticClass: "active",
    attrs: {
      "href": _vm.$t('breadcrumbGwLink')
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('breadcrumbGw')))])])], 1), _vm._v(" "), _c('article-filter-wg'), _vm._v(" "), _c('picture-wall', {
    ref: "pictureWall"
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      leftSection: true, rightBorder: true, floatLeft: true, invisible: _vm.hideLeftMenu
    }
  }, [(_vm.currentPicker) ? _c('div', {
    staticClass: "closePicker hide-for-mobile"
  }, [_c('div', {
    staticClass: "inner",
    on: {
      "click": function($event) {
        _vm.closePickers('all')
      }
    }
  }, [_c('i', {
    staticClass: "icon-close"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      logo: true, hideOnMobile: _vm.currentLeftTitle
    }
  }, [_c('img', {
    attrs: {
      "src": "https://checkout.desenio.se/frontend/view_desktop/design/logos/desenio-logo-black.svg"
    },
    on: {
      "click": _vm.goToDesenio
    }
  })]), _vm._v(" "), (_vm.currentPicker) ? _c('div', {
    staticClass: "topPanel relative row"
  }, [_c('div', {
    staticClass: "name tiny-heading u-pull-left"
  }, [_vm._v(" " + _vm._s(_vm.currentLeftTitle) + " ")])]) : _vm._e(), _vm._v(" "), _c('loader', {
    attrs: {
      "classes": "cover dimmer",
      "identifier": "picker"
    }
  }), _vm._v(" "), _c('picker'), _vm._v(" "), _c('frame-picker'), _vm._v(" "), _c('article-picker'), _vm._v(" "), _c('basket'), _vm._v(" "), _c('div', {
    staticClass: "bottomActions"
  }, [(_vm.currentPicker) ? _c('next-step') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "leftMenu",
    class: {
      active: _vm.showMenu
    }
  }, [_c('div', {
    class: {
      menuItem: true, hoverFade: true, done: _vm.steps.background
    },
    on: {
      "click": function($event) {
        _vm.openPicker('backgrounds')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "name raleway"
  }, [_vm._v(" " + _vm._s(_vm.$t('pick')) + " " + _vm._s(_vm.$tc('background', 1)))])]), _vm._v(" "), _c('div', {
    class: {
      menuItem: true, hoverFade: true, done: _vm.steps.pictureWall
    },
    on: {
      "click": function($event) {
        _vm.openPicker('pictureWalls')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('span', {
    staticClass: "name raleway"
  }, [_vm._v(_vm._s(_vm.$t('pick')) + " " + _vm._s(_vm.$tc('picturewall', 1)))])]), _vm._v(" "), _c('div', {
    class: {
      menuItem: true, hoverFade: true, done: _vm.steps.motifs
    },
    attrs: {
      "id": "pickMotifs"
    },
    on: {
      "click": _vm.openBasket
    }
  }, [_vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('span', {
    staticClass: "name raleway"
  }, [_vm._v(_vm._s(_vm.$t('pick')) + " " + _vm._s(_vm.$tc('motifs', 1)))])]), _vm._v(" "), _c('div', {
    class: {
      menuItem: true, hoverFade: true, done: _vm.steps.frames
    },
    on: {
      "click": _vm.openFramePicker
    }
  }, [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('frameYourMotifs')) + " ")])])]), _vm._v(" "), (!_vm.currentPicker) ? _c('div', {
    staticClass: "buyLeft"
  }, [_c('price'), _vm._v(" "), (_vm.buyButtonActive) ? _c('div', [_c('div', {
    staticClass: "button cta adapted buyButtonLeft hoverFade",
    on: {
      "click": _vm.buy
    }
  }, [_c('loader', {
    attrs: {
      "classes": "",
      "inline": true,
      "identifier": "buyButton"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('addToCart')) + "\n            "), _c('img', {
    staticClass: "bagImg",
    attrs: {
      "src": _vm.wgURL + '/icons/shopbag.png',
      "alt": ""
    }
  })], 1)]) : _c('div', [_c('div', {
    staticClass: "button cta adapted buyButtonLeft",
    staticStyle: {
      "background-color": "#888",
      "border": "none"
    }
  }, [_c('loader', {
    attrs: {
      "classes": "",
      "inline": true,
      "identifier": "buyButton"
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('addToCart')) + "\n            "), _c('img', {
    staticClass: "bagImg",
    attrs: {
      "src": _vm.wgURL + '/icons/shopbag.png',
      "alt": ""
    }
  })], 1)])], 1) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  }), _vm._v(" Ritningar ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-pictures"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "number"
  }, [_vm._v("1 "), _c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-picture-wall"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "number"
  }, [_vm._v("2 "), _c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-article"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "number"
  }, [_vm._v("3 "), _c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-frame"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "number"
  }, [_vm._v("4 "), _c('i', {
    staticClass: "fa fa-check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e0ccdbc!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Home.vue
// module id = 166
// module chunks = 0